<template>
    <row>
        <column cols="12" md="7" lg="8">
            <card xs-tile>
                <activity-feed id="newsfeed"
							   :url="`/v1/events/${eventStore.event.id}/activities`"
							   :model="eventStore.event" without-create :params="{self: true}" flat/>
            </card>
        </column>

        <column v-if="!eventStore.event.is_managed_by_organizer || featureElements?.length || ads?.length" cols="12" md="5" lg="4">
            <sticky-content breakpoint="md">
                <lazy-event-feature-element-card v-if="!eventStore.event.is_managed_by_organizer || featureElements?.length || ads?.length" :elements="featureElements" :ads="ads" :event="eventStore.event" xs-tile sm-tile/>
            </sticky-content>
        </column>
    </row>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$api, $web} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.News)) {
	await navigateTo($web('events.show', route.params.event));
}

let featureElements = [];
let ads = [];
try {
	const {data} = await useApiFetch($api('events.feature_elements.index', eventStore.event.id), {
		guest: true
	})
	featureElements = data.elements;
	ads = data.ads;
} catch (e) {
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.activities.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.activities.index.description', {event: eventStore.event.display_name})
})

</script>

